// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"896d470a","453":"ccb5b5d7"}[chunkId] + ".chunk.js";
};